import React from 'react';
import { homeHref } from '../siteHome.mjs';

export default function PredictionsLayout({ children }) {
  return (
    <div className="pred-app">
      <header className="pred-header">
        <a className="pred-brand" href="/">
          🔮 Personal Predictions
        </a>
        <nav className="pred-header-nav">
          <a className="pred-header-link" href="/about.html">
            About
          </a>
          <a className="pred-header-link" href={homeHref()}>
            Side Quests
          </a>
        </nav>
      </header>
      <main className="pred-main">{children}</main>
    </div>
  );
}
